import { DisableLayerStyled } from './style';

export const DisableLayer = DisableLayerStyled;
